import { getApiUrls } from "../lib/apiUrl";

const { appApiUrl } = getApiUrls();

type PostAppGraphqlParams = {
  token: string;
  operationName: string;
  query: string;
  variables?: Record<string, unknown>;
  throwOnErrors?: boolean;
  keepalive?: boolean;
};

type GraphqlError = {
  message?: string;
};

type GraphqlPayload<T> = {
  data?: T;
  errors?: GraphqlError[];
};

export async function postAppGraphql<TData>(
  params: PostAppGraphqlParams,
): Promise<GraphqlPayload<TData>> {
  const {
    token,
    operationName,
    query,
    variables,
    throwOnErrors = true,
    keepalive = false,
  } = params;

  if (!token.trim()) {
    throw new Error("Missing auth token.");
  }
  if (!appApiUrl) {
    throw new Error("App API URL is not configured.");
  }

  const response = await fetch(`${appApiUrl}/graphql?op=${operationName}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query,
      ...(variables ? { variables } : {}),
    }),
    ...(keepalive ? { keepalive: true } : {}),
  });

  if (!response.ok) {
    throw new Error(`GraphQL request failed (${response.status}).`);
  }

  const payload = (await response.json()) as GraphqlPayload<TData>;
  if (throwOnErrors && payload.errors?.length) {
    throw new Error(payload.errors[0]?.message ?? "GraphQL request failed.");
  }

  return payload;
}
